@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [data]="AzurePersonList"
    [filterable]="true"
    (filterChange)="filterAzurePersons($event)"
    (valueChange)="valueChanged()"
    placeholder="Wählen Sie einen User aus!"
    [(ngModel)]="AzurePersons">
    @if (false; as dataItem) {
      <ng-template kendoDropDownListItemTemplate let-dataItem>
        <img src="{{ dataItem.image }}" alt="picture" width="40"> {{ dataItem.name }}
      </ng-template>
    }
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="form-control k-widget"
    textField="name"
    valueField="id"
    [data]="AzurePersonList"
    (valueChange)="valueChanged()"
    [(ngModel)]="AzurePerson">
    @if (false; as dataItem) {
      <ng-template kendoDropDownListItemTemplate let-dataItem>
        <img src="{{ dataItem.image }}" alt="" width="40"> {{ dataItem.name }}
      </ng-template>
    }
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}
